import { Star } from "lucide-react";

export function Stars({ rating = 0, size = 14, className = "", showZero = false }) {
    const r = Math.round(Number(rating) || 0);
    if (!r && !showZero) return null;
    const stars = [1, 2, 3, 4, 5];
    return (
        <div className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${r} of 5 stars`}>
            {stars.map((s) => (
                <Star
                    key={s}
                    size={size}
                    className={s <= r ? "fill-skyblueDeep text-skyblueDeep" : "text-inkDark/15"}
                />
            ))}
        </div>
    );
}
